export default class TeamColors {
  primary: string = null;
  secondary: string = null;
  tertiary: string = null;
}
